import { Component, isDevMode } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Sistemas } from './data/sistemas';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  production = environment.production;
  sistemas = Sistemas;
  showRedAlert = isDevMode();
}
